import * as React from "react";

export const VitalSignsIcon: React.FC = () => (
  <svg
    width="51px"
    height="40px"
    viewBox="0 0 51 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <desc>Created with sketchtool.</desc>
    <defs>
      <linearGradient
        x1="67.4819381%"
        y1="87.4094365%"
        x2="19.0836497%"
        y2="4.71260974%"
        id="linearGradient-1"
      >
        <stop stopColor="#F27B6E" offset="16.6004335%"></stop>
        <stop stopColor="#F1D22F" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="CareGEM-Patient-Report-Symptoms-V1.1-O3"
        transform="translate(-54.000000, -534.000000)"
      >
        <g id="Group-5" transform="translate(29.000000, 503.000000)">
          <g id="Group-17" transform="translate(25.000000, 31.000000)">
            <polygon
              id="Path-30"
              fill="url(#linearGradient-1)"
              points="33.5251424 19.1321 48.9642857 19.1321 46.3780193 23.3066234 41.3410561 28.3091695 36.7084654 31.8566234 32.026695 35.0897101 25.5619382 38.3066234 21.026695 36.2749992 15.5629082 33.2256653 10.026695 28.3091695 5.02669498 23.3066234 1.71751888 19.1321 14.7992927 19.1321 18 13.9554 22.4502006 24 26.8935515 17.4461 30.2882511 22.3556755"
            ></polygon>
            <polygon
              id="Path-2"
              fill="#FFFFFF"
              points="1.01474012 11.148 3.67811843 5.3243 8.17796806 2 14.2268061 0.9454 19.9863617 2.3714 23.3376295 4.40193176 25.5299677 7.66170949 28.2518324 4 32 2 36.8749695 1.1877 42.3330955 1.55448455 46.2857143 4.60093564 49.5814327 8.4131 49.5814327 13 49.5814327 17.4461 48.9642857 18.5119002 33.5251424 19.2698 30.3159506 22.783969 26.7847248 17 22.7077765 24.2297 18 13 14.9290922 19 2.34732907 19.3364591 1.01474012 16.3666"
            ></polygon>
            <path
              d="M37.0429688,0 C41.0455929,0 44.3307163,1.17056121 46.8984375,3.51171875 C49.4661587,5.85287629 50.75,9.06247961 50.75,13.140625 C50.75,17.2942916 49.2018384,21.2590957 46.1054688,25.0351562 C43.0846203,28.7356956 39.3086164,32.058579 34.7773438,35.0039062 C32.9648347,36.2122456 31.2656329,37.2128867 29.6796875,38.0058594 C28.0937421,38.7988321 26.9609409,39.3085926 26.28125,39.5351562 L25.375,39.875 C23.2604061,39.3463515 20.1263229,37.7226698 15.9726562,35.0039062 C11.4413836,32.058579 7.66537969,28.7356956 4.64453125,25.0351562 C1.5481616,21.2590957 0,17.2942916 0,13.140625 C0,9.06247961 1.28384133,5.85287629 3.8515625,3.51171875 C6.41928367,1.17056121 9.70440707,0 13.7070312,0 C16.0481888,0 18.2949111,0.528640547 20.4472656,1.5859375 C22.5996201,2.64323445 24.2421818,4.11587598 25.375,6.00390625 C26.5078182,4.11587598 28.1503799,2.64323445 30.3027344,1.5859375 C32.4550889,0.528640547 34.7018112,0 37.0429688,0 Z M44.7460938,23.9023438 C46.1809968,22.2408771 47.2382779,20.3906352 47.9179688,18.3515625 C48.5976596,16.5390534 48.9375,14.8020916 48.9375,13.140625 C48.9375,9.59112809 47.8424589,6.7968852 45.6523438,4.7578125 C44.5195256,3.70051555 43.2734443,2.9830748 41.9140625,2.60546875 C40.5546807,2.07682027 38.930999,1.8125 37.0429688,1.8125 C32.3606537,1.8125 29.0000102,3.51170176 26.9609375,6.91015625 L25.375,9.515625 L23.7890625,6.91015625 C21.7499898,3.51170176 18.3893463,1.8125 13.7070312,1.8125 C11.819001,1.8125 10.1953193,2.07682027 8.8359375,2.60546875 C7.4765557,2.9830748 6.23047441,3.70051555 5.09765625,4.7578125 C2.90754113,6.7968852 1.8125,9.59112809 1.8125,13.140625 C1.8125,14.8020916 2.15234035,16.5390534 2.83203125,18.3515625 C3.51172215,20.3906352 4.56900324,22.2408771 6.00390625,23.9023438 C7.7408941,26.0169377 9.2890557,27.6783794 10.6484375,28.8867188 C12.0078193,30.0950581 14.1223815,31.6432197 16.9921875,33.53125 C20.1640784,35.6458439 22.9583212,37.1184854 25.375,37.9492188 C27.7916788,37.1184854 30.5859216,35.6458439 33.7578125,33.53125 C36.6276185,31.6432197 38.7421807,30.0950581 40.1015625,28.8867188 C41.4609443,27.6783794 43.0091059,26.0169377 44.7460938,23.9023438 Z"
              id="ion-ios-heart-outline---Ionicons-Copy"
              fill="#212B40"
            ></path>
            <polyline
              id="Path-23-Copy"
              stroke="#212B40"
              strokeWidth="1.8"
              points="2 19.1502 14.895134 19.1502 18.005192 13 22.6868293 24.4462 26.7658974 16.8084 30.2948084 23.0282262 33.659816 19.1502 48.9375 19.1502"
            ></polyline>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
